/**
 * @file cookie条款的hook
 * @author aron.yao
 */
import { useEffect } from 'react'
import Scio from '@4f2e/scio'
import cookieRef from '@/services/cookieReference'
import { initGA } from '@/utils/ga'
import { currentLocaleConfig } from '@/i18n'

let scio: Scio

export default function useCookieReference() {
  useEffect(() => {
    if (currentLocaleConfig.inWhitelist) {
      if (scio) return

      scio = cookieRef.init()
      scio.on('initialized', () => initGA())
    } else {
      initGA()
    }
  }, [])
}
